export default "__VITE_ASSET__9ffe0b8e__"